import { StatusOption } from '../../utils'

export enum EmailValidityStatusEnum {
  VALID = 'VALID',
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN'
}

export const emailValidityStatusEnumMapping: Record<EmailValidityStatusEnum, StatusOption> = {
  [EmailValidityStatusEnum.VALID]: { label: 'Valide', variant: 'success' },
  [EmailValidityStatusEnum.INVALID]: { label: 'Invalide', variant: 'danger' },
  [EmailValidityStatusEnum.UNKNOWN]: { label: 'NA', variant: 'grey' }
}
